import { data } from '../../svg/Flip/data';
import { makeIcon } from '../makeIcon';

export const Flip = makeIcon(data, 'flip', 'Flip');

export default Flip;
